__turbopack_context__.v({
  "container": "enrollment-box-module-scss-module__7W2UGW__container",
  "container--with-margin": "enrollment-box-module-scss-module__7W2UGW__container--with-margin",
});
